import { useEffect, useState } from 'react';
import { useRequisitePdfService, useRequisiteService } from 'app/utils/services/requisiteService';
import logger from 'app/utils/logger';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface Props {
  accountValue: string;
  accountCurrency: string;
}

const useRequisiteModal = (props: Props) => {
  const { t } = useTranslation();
  const { accountValue, accountCurrency } = props;
  const [showRequisiteModal, setShowRequisiteModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const location = useLocation();
  const path = location.pathname.substring(3);
  const search = location.search;

  const { isLoadingRequisite, dataRequisite, requisiteMutation } = useRequisiteService(`${path}${search}`);
  const { isLoadingRequisitePdf, isSuccessRequisitePdf, dataRequisitePdf, requisitePdfMutation } =
    useRequisitePdfService(`${path}${search}`);

  const handleOnClickRequisite = () => {
    setShowRequisiteModal(true);
    requisiteMutation({ acc_no: accountValue, currency: accountCurrency });
  };

  const handleClickDownload = () => {
    requisitePdfMutation({ acc_no: accountValue, type: 'pdf_file' });
  };

  useEffect(() => {
    const file = document.getElementById('file');
    if (file !== null) {
      file.click();
      setShowRequisiteModal(false);
    }
  }, [dataRequisitePdf]);

  const handleCopy = () => {
    // setShowRequisiteModal(false);
    const requisiteData = document.getElementById('requisiteData').innerText;
    navigator.clipboard.writeText(requisiteData);
    setShowSnackbar(true);
  };

  return {
    t,
    showRequisiteModal,
    showSnackbar,
    setShowRequisiteModal,
    isLoadingRequisite,
    dataRequisite,
    isSuccessRequisitePdf,
    dataRequisitePdf,
    handleOnClickRequisite,
    handleClickDownload,
    handleCopy,
    setShowSnackbar,
  };
};

export default useRequisiteModal;
